// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../work/nmcp-client/nmcp-client/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../work/nmcp-client/nmcp-client/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * @license
 * Copyright 2020 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

.neuroglancer-selection-details-body {
  height: 0px;
  flex: 1;
  overflow-y: auto;
  flex-basis: 0px;
  min-height: 0px;
}

.neuroglancer-selection-details-position {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-items: left;
  font-family: monospace;
  font-size: medium;
}

.neuroglancer-selection-details-position-dimension
  + .neuroglancer-selection-details-position-dimension {
  margin-left: 8px;
}

.neuroglancer-selection-details-position-dimension-name {
  color: #ff6;
}

.neuroglancer-selection-details-position-dimension-coordinate {
  margin-left: 5px;
  user-select: text;
}

.neuroglancer-selection-details-layer {
  margin-top: 4px;
  margin-bottom: 4px;
  border: 1px solid #222;
}

.neuroglancer-selection-details-layer-title {
  cursor: pointer;
  background-color: #222;
  font-family: sans-serif;
  font-size: 10pt;
}

.neuroglancer-selection-details-layer-title:hover {
  background-color: #333;
}

.neuroglancer-selection-details-layer-body {
  padding: 2px;
  display: flex;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./../../../../nmcp-neuroglancer/dist/package/lib/ui/selection_details.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;EAcE;;AAEF;EACE,WAAW;EACX,OAAO;EACP,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB","sourcesContent":["/**\n * @license\n * Copyright 2020 Google Inc.\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *      http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n */\n\n.neuroglancer-selection-details-body {\n  height: 0px;\n  flex: 1;\n  overflow-y: auto;\n  flex-basis: 0px;\n  min-height: 0px;\n}\n\n.neuroglancer-selection-details-position {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-items: left;\n  font-family: monospace;\n  font-size: medium;\n}\n\n.neuroglancer-selection-details-position-dimension\n  + .neuroglancer-selection-details-position-dimension {\n  margin-left: 8px;\n}\n\n.neuroglancer-selection-details-position-dimension-name {\n  color: #ff6;\n}\n\n.neuroglancer-selection-details-position-dimension-coordinate {\n  margin-left: 5px;\n  user-select: text;\n}\n\n.neuroglancer-selection-details-layer {\n  margin-top: 4px;\n  margin-bottom: 4px;\n  border: 1px solid #222;\n}\n\n.neuroglancer-selection-details-layer-title {\n  cursor: pointer;\n  background-color: #222;\n  font-family: sans-serif;\n  font-size: 10pt;\n}\n\n.neuroglancer-selection-details-layer-title:hover {\n  background-color: #333;\n}\n\n.neuroglancer-selection-details-layer-body {\n  padding: 2px;\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
